<div class="tw-flex tw-flex-col tw-bg-gray-100 tw-h-full">
    <loading class="pos-fix vh-center" *ngIf="!doctor"></loading>
    <div class="tw-fixed tw-left-6 tw-top-3 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
    </div>
    <section class="tw-flex-1 tw-overflow-y-auto tw-pt-12 tw-bg-white" *ngIf="doctor">
        <doctor-profile class="tw-h-full" [doctor]="doctor"></doctor-profile>
    </section>
</div>